import React from 'react'
import { connect } from 'react-redux'

import { gettext } from '@bikemap/js/services'
import { toggleDebugMode } from '../../actions'
import { CheckboxField, DropdownItem } from '@bikemap/components'

/**
 * Item for the user menu of staff users to toggle debug mode.
 * @param {Object} props
 * @param {boolean} props.value
 * @param {(value: boolean) => void} props.onChange
 */
const DebugModeActionItem = ({ value, onChange }) => {
    const debugText = gettext('Show debug info')

    return (
        <DropdownItem>
            <CheckboxField value={value} onChange={onChange} name="debug-mode">
                {debugText}
            </CheckboxField>
        </DropdownItem>
    )
}

const mapStateToProps = ({ debugging }) => ({ value: debugging })

const mapDispatchToProps = dispatch => ({
    onChange: value => dispatch(toggleDebugMode(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DebugModeActionItem)
